<template>
  <div class="left-chart-wrap">
    <chart-widget />
    <linked-articles />
    <events-calendar />
  </div>
</template>

<script>
import ChartWidget from './ChartWidget'
import EventsCalendar from './EventsCalendar'
import LinkedArticles from './LinkedArticles'
export default {
  components: {
    'chart-widget': ChartWidget,
    'events-calendar': EventsCalendar,
    'linked-articles': LinkedArticles,
  },
}
</script>

<style></style>
